import React from 'react';
import ExpIconBottom from '../../ExpIconBottom';
import YouTube from 'react-youtube';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  videoContainer:{
    display: 'grid', 
    gridTemplateColumns: 'repeat(3, 1fr)', 
    gridColumnGap: 16, 
    gridRowGap: 24,
    '@media(max-width: 580px)': {
      gridTemplateColumns: '1fr',
      gridRowGap: 16,
    }
  },
  marginContainer: {
    marginBottom: 16
  }
}));

const opts = {
  height: 'auto',
  width: '100%',
  playerVars: {
    autoplay: 0,
  },
};
const _onReady = event => {
  // access to player in all event handlers via event.target
  event.target.pauseVideo();
};
function CardVideos(props) {
  const classes = useStyles();
  const { authClient, publicVideosYT } = props
  let arrVideos;
  arrVideos = authClient && authClient.videosYoutube ? authClient.videosYoutube.slice() : publicVideosYT ? publicVideosYT.slice() : []

  function YouTubeGetID(item){
    var videoid = item.youtube.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if(videoid != null) {
      return videoid[1]
    }
  }

  function YouTubeGetID(item){
    var videoid = item.youtube.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if(videoid != null) {
      return videoid[1]
    }
  }

  return (
    <>
      <ExpIconBottom
        title="Videos"
        sumcontent={
          <div className={`${classes.videoContainer} ${classes.marginContainer}`}>
            { /*  {authClient && authClient.videosYoutube.map((video, index) => { */}

            {arrVideos.map((video, index) => {
              return (
                <>
                  {index <= 2 ?
                    <YouTube
                      key={index}
                      videoId={YouTubeGetID(video)}
                      opts={opts}
                      onReady={_onReady}
                    />
                    : null
                  }
                </>
              );
            })

            }
          </div>
        }
        detcontent={
          <div className={classes.videoContainer}>
            {arrVideos.map((video, index) => {
              return (
                <>
                  {index >= 3 ?
                    <YouTube
                      key={index}
                      videoId={YouTubeGetID(video)}
                      opts={opts}
                      onReady={_onReady}
                    />
                    : null
                  }
                </>
              );
            })}
          </div>
        }
        expansionButton={arrVideos.length>3? true:false}
      />
    </>
  );
}
export default CardVideos;